<div class="toolbox-component" id="gallery">
  <div class="header">
    <div class="header-title">
      <span class="header-title-main">
        {{ 'i18n.button.photos' | translate }}
      </span>
      @if (imagesCount > 0) {
        <span class="header-title-sub">
          ({{ imagesCount }})
        </span>
      }
    </div>
    <mat-icon svgIcon="close"
      class="close-x"
      (click)="btnCloseClick()">
    </mat-icon>
  </div>
  <gallery
    (imageClicked)="handleImageClick($event)"
    (imageDeleted)="resetImagePlaceholder($event)">
  </gallery>
</div>
